import React from 'react';
import { FadeIn } from './FadeIn';
const phases = [{
  num: '01',
  title: 'El Reset Fisiológico',
  desc: 'El interruptor térmico para forzar a tu sistema nervioso a salir del estado de alerta y entrar en modo de calma.'
}, {
  num: '02',
  title: 'La Mecánica del Enfoque',
  desc: 'La secuencia de etiquetado y anclaje sensorial que cierra los procesos abiertos en tu cabeza.'
}, {
  num: '03',
  title: 'Desarmado de la Catástrofe',
  desc: 'Cómo neutralizar los pensamientos intrusivos y transformar el pánico en una hoja de ruta logística.'
}, {
  num: '04',
  title: 'Reset Invisible',
  desc: 'Cómo recuperar el mando en la oficina o en reuniones sin que nadie note absolutamente nada.'
}];
export function SolutionSection() {
  return <section className="py-24 lg:py-32 bg-navy-900 border-t border-steel-800" data-id="element-151">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-152">
        <FadeIn data-id="element-153">
          <div className="text-center mb-20" data-id="element-154">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-8 leading-tight" data-id="element-155">
              LA SOLUCIÓN NO ES ANALIZAR EL PROBLEMA.
              <br data-id="element-156" />
              <span className="text-amber-500 italic" data-id="element-157">
                ES RESETEAR EL SISTEMA.
              </span>
            </h2>
            <p className="text-lg text-offwhite/80 max-w-2xl mx-auto" data-id="element-158">
              Este manual no contiene autoayuda. Contiene un Protocolo de
              Ingeniería Cognitiva diseñado para la intervención inmediata en
              medio del caos.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-159">
          {phases.map((phase, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-160">
              <div className="p-8 lg:p-10 bg-navy-800 border border-steel-800 rounded-sm relative overflow-hidden group hover:border-amber-500/30 transition-colors h-full" data-id="element-161">
                <div className="absolute top-0 right-0 p-6 text-6xl font-serif font-bold text-navy-900/50 select-none group-hover:text-navy-900/80 transition-colors" data-id="element-162">
                  {phase.num}
                </div>
                <div className="relative z-10" data-id="element-163">
                  <div className="text-amber-500 font-bold tracking-widest text-sm mb-4 uppercase" data-id="element-164">
                    Fase {phase.num}
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4 font-serif" data-id="element-165">
                    {phase.title}
                  </h3>
                  <p className="text-offwhite/80 leading-relaxed" data-id="element-166">
                    {phase.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}